import { useTranslation } from 'react-i18next'
import { useCookieConsentStore } from '@/store/cookieConsent'
import { updateConsent } from '@/lib/consentMode'

export default function CookieConsentBanner() {
  const { t } = useTranslation()
  const status = useCookieConsentStore((state) => state.status)
  const setStatus = useCookieConsentStore((state) => state.setStatus)

  if (status !== 'pending') return null

  const handleChoice = (granted: boolean) => {
    setStatus(granted ? 'accepted' : 'rejected')
    updateConsent(granted)
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg p-4 sm:p-6">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1">
          <p className="font-bold text-foreground text-sm">{t('cookieConsent.title')}</p>
          <p className="text-xs text-foreground/70 mt-1">{t('cookieConsent.description')}</p>
        </div>
        <div className="flex gap-2 shrink-0">
          <button
            className="px-4 py-2 text-sm font-medium rounded-lg border border-gray-200 text-foreground hover:bg-gray-50 transition-colors"
            onClick={() => handleChoice(false)}
          >
            {t('cookieConsent.reject')}
          </button>
          <button
            className="px-4 py-2 text-sm font-medium rounded-lg bg-primary text-on-primary hover:bg-primary/90 transition-colors"
            onClick={() => handleChoice(true)}
          >
            {t('cookieConsent.accept')}
          </button>
        </div>
      </div>
    </div>
  )
}
